import { render } from "./RecruitmentinformationPage.vue?vue&type=template&id=50edb954&scoped=true"
import script from "./RecruitmentinformationPage.vue?vue&type=script&lang=js"
export * from "./RecruitmentinformationPage.vue?vue&type=script&lang=js"

import "./RecruitmentinformationPage.vue?vue&type=style&index=0&id=50edb954&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50edb954"]])

export default __exports__